<template>
  <div class="login">
    <div class="text-center">
      <img :src="require('../assets/logo.png')" />
    </div>
    <div class="input-container">
      <input v-model="login" type="text" name="login" />
      <label for="login">login</label>
    </div>
    <div class="input-container">
      <input v-model="password" type="password" name="password" />
      <label for="password">password</label>
    </div>

    <transition name="fadein">
      <div style="color: red;" class="slowShow" v-if="tried && loginTries > 0">
        Invalid login and password!
      </div>
    </transition>
    <div>
      <button
        type="button"
        class="btn"
        v-on:click="
          loginFn({ login, password });
          loginTries++;
        "
      >
        Login
      </button>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";

export default {
  data: () => ({
    login: "",
    password: "",
    loginTries: 0
  }),
  mounted() {
    this.loginFn("test", "test");
  },
  computed: mapState({
    tried: state => state.loggedTry
  }),
  methods: {
    ...mapActions({
      loginFn: "login"
    })
  }
};
//context.commit("openBySlug", { slug });
</script>
<style lang="scss" scoped>
.login {
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  padding: 2rem;
  border: 1px grey solid;

  .input-container {
    position: relative;
    margin-bottom: 25px;
  }
  .input-container label {
    position: absolute;
    top: 0px;
    left: 0px;
    font-size: 16px;
    color: #bbb;
    pointer-event: none;
    transition: all 0.5s ease-in-out;
  }
  .input-container input {
    border: 0;
    border-bottom: 1px solid #555;
    background: transparent;
    width: 100%;
    padding: 8px 0 5px 0;
    font-size: 16px;
    color: #fff;
  }
  .input-container input:focus {
    border: none;
    outline: none;
    border-bottom: 1px solid #1abc9c;
  }
  .btn {
    color: #fff;
    background-color: #1abc9c;
    outline: none;
    border: 0;
    color: #fff;
    padding: 10px 20px;
    text-transform: uppercase;
    margin-top: 50px;
    border-radius: 2px;
    cursor: pointer;
    position: relative;
  }
  .input-container input:focus ~ label,
  .input-container input:valid ~ label {
    top: -12px;
    font-size: 12px;
  }
  .text-center {
    color: #fff;
    text-transform: uppercase;
    img {
      max-width: 100px;
    }
    h1 {
      font-size: 23px;
      font-weight: normal;
    }
    margin: -10px 0 60px 0;
    display: block;
    text-align: center;
  }
}
.fadein-enter-active {
  opacity: 0;
  animation: fadein 0.2s 0.5s;
}
@keyframes fadein {

  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
